export const getTriggerIcon = (vueObj) => {
  if (!vueObj.triggerCands.includes(vueObj.candidate.candidateID)) {
    return require("../../assets/img/newkanban/gray-tick-trigger.svg");
  } else {
    return require("../../assets/img/newkanban/whitetick.svg");
  }
};

export const showGrayTick = (vueObj) => {
  if (vueObj.sendScreening || vueObj.triggerReport)
    return !vueObj.triggerCands.includes(vueObj.candidate.candidateID);
  else
    return (
      vueObj.candidate.cvsStatus != 2 &&
      vueObj.triggerCVS &&
      !vueObj.triggerCands.includes(vueObj.candidate.candidateID)
    );
};

export const showWhiteTick = (vueObj) => {
  if (vueObj.sendScreening || vueObj.triggerReport)
    return vueObj.triggerCands.includes(vueObj.candidate.candidateID);
  else
    return (
      vueObj.candidate.cvsStatus != 2 &&
      vueObj.triggerCVS &&
      vueObj.triggerCands.includes(vueObj.candidate.candidateID)
    );
};

export const getCVSStatus = (candidate) => {
  if (candidate.cvsStatus == 1) {
    return "Triggered";
  } else if (candidate.cvsStatus == 2) {
    return "Submitted";
  }
  return "Not Triggered";
};

export const calculateVisibleTags = (vueObj) => {
  const container = vueObj.$refs.container;
  const containerWidth = container?.offsetWidth - 40;

  // Create measurement span
  const temp = document.createElement("span");
  temp.style.visibility = "hidden";
  temp.style.position = "absolute";
  temp.style.whiteSpace = "nowrap";
  temp.className = "tag";
  document.body.appendChild(temp);

  // Create more-tag span
  const moreSpan = document.createElement("span");
  moreSpan.style.visibility = "hidden";
  moreSpan.style.position = "absolute";
  moreSpan.style.whiteSpace = "nowrap";
  moreSpan.className = "more-tag";
  moreSpan.innerText = `+${
    vueObj.candidate.customFields.notesTags.length - 1
  } more`;
  document.body.appendChild(moreSpan);

  const moreTagWidth = moreSpan?.offsetWidth + 8;
  let totalWidth = 0;
  const visible = [];

  for (let i = 0; i < vueObj.candidate.customFields.notesTags.length; i++) {
    temp.innerText = vueObj.candidate.customFields.notesTags[i];
    const tagWidth = temp.offsetWidth + 8;

    const isLastFittable =
      i < vueObj.candidate.customFields.notesTags.length - 1;
    const roomLeft = containerWidth - totalWidth;
    const requiredWidth = tagWidth + (isLastFittable ? moreTagWidth : 0);
    if (requiredWidth <= roomLeft || visible.length === 0) {
      // Show at least one tag, even if it doesn’t fully fit
      visible.push(vueObj.candidate.customFields.notesTags[i]);
      totalWidth += tagWidth;
    } else {
      break;
    }
  }

  vueObj.visibleTags = visible;
  vueObj.remainingCount =
    vueObj.candidate.customFields.notesTags.length - visible.length;

  document.body.removeChild(temp);
  document.body.removeChild(moreSpan);
};

export const calculateVisibleSubTags = (tags, vueObj) => {
  const container = document.createElement("div");
  container.style.visibility = "hidden";
  container.style.position = "absolute";
  container.style.width = "200px"; // Match the actual tooltip tag area width
  container.style.display = "flex";
  container.style.flexWrap = "wrap";
  document.body.appendChild(container);

  let lineHeights = [];
  let tagElements = [];
  let visible = [];

  tags.forEach((tag) => {
    const el = document.createElement("div");
    el.innerText = `#${tag}`;
    // el.style.padding = "3px 6px";
    // el.style.fontSize = "12px";
    // el.style.margin = "3px";
    // el.style.whiteSpace = "nowrap";
    // el.style.backgroundColor = "#ccc";
    // el.style.borderRadius = "4px";
    // el.style.display = "inline-block";

    container.appendChild(el);
    tagElements.push(el);
  });

  let firstTop = null;
  // let rowCount = 0;

  for (let i = 0; i < tagElements.length; i++) {
    const top = tagElements[i].getBoundingClientRect().top;
    if (firstTop === null) firstTop = top;

    if (!lineHeights.includes(top)) {
      lineHeights.push(top);
    }

    if (lineHeights.length > 3) break;

    visible.push(tags[i]);
  }

  document.body.removeChild(container);

  vueObj.visibleSubTags = visible;
  vueObj.count = tags.length - visible.length;
};

export const removeTooltip = (vueObj) => {
  vueObj.$emit("show-blur", false);
  vueObj.$refs.tooltip.$emit("close");
};
